<template>
  <div>
    <b-row>
      <b-col md="12" class="text-center mb-2">
        <h1 class="mt-2">{{ $t("createAccount") }}</h1>
        <p v-html="$t('registrationText')"></p>
      </b-col>
    </b-row>
    <register-form redirect-route="waiting" :partner-ref="partnerRef" :company="company" :email="email"></register-form>
    <b-row class="text-center">
      <b-col md="12">
        <p class="mt-3 mb-3 float-right">
          <router-link to="/login">
            {{ $t("doYouAlreadyHaveAnAccount") }}
          </router-link>
        </p>
      </b-col>
    </b-row>
  </div>
</template>

<script>
// @ is an alias to /src
import RegisterForm from "@/components/RegisterForm.vue";

export default {
  name: "RegisterView",
  components: {
    RegisterForm
  },
  data() {
    return {
      partnerRef: this.$route.params.partnerRef,
      company: this.$route.query.company,
      email: this.$route.query.email
    };
  },
  mounted() {}
};
</script>
<style scoped lang="scss"></style>
